module.exports = __webpack_public_path__ + "img/annotated_fence_large.78a827e2.png";